// /src/components/tools/memberProfileCard/PerkThemeNebulaCanvas.jsx
// Volumetric nebula inspired by CSS 3D clouds (clicktorelease): soft billboard
// puffs in a perspective field. Transparent (no sky fill); teal / cyan / ochre.

import React, { useMemo } from 'react';

const COLOR_VARIANTS = 6;
const MAX_LAYERS = 42;

function clampQty(value, fallback = 50) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.max(0, Math.min(100, Math.round(n)));
}

function step10(value, fallback = 50) {
  return Math.round(clampQty(value, fallback) / 10) * 10;
}

function layerCountForQuantity(quantity) {
  const q = clampQty(quantity, 55);
  return Math.max(14, Math.round(14 + (q / 100) * (MAX_LAYERS - 14)));
}

/**
 * @param {{
 *   quantity?: number,
 *   inclination?: number,
 *   motion?: number,
 * }} props
 * quantity 0–100 density · inclination 0–100 tilt · motion 0–100 (0=still, 100=aurora)
 */
export default function PerkThemeNebulaCanvas({
  quantity = 55,
  inclination = 50,
  motion = 40,
}) {
  const qty = clampQty(quantity, 55);
  const count = layerCountForQuantity(qty);

  const layers = useMemo(
    () => Array.from({ length: count }, (_, i) => i),
    [count],
  );

  const qtyStep = step10(qty, 55);
  const inclineStep = step10(inclination, 50);
  const motionStep = step10(motion, 40);

  return (
    <div
      className={[
        'perk-theme-overlay__layer',
        'perk-theme-overlay__layer--nebula',
        `perk-theme-overlay__layer--nebula-q${qtyStep}`,
        `perk-theme-overlay__layer--nebula-i${inclineStep}`,
        `perk-theme-overlay__layer--nebula-m${motionStep}`,
      ].join(' ')}
      aria-hidden
    >
      <div className="perk-theme-overlay__nebula-stage">
        <div className="perk-theme-overlay__nebula-world">
          {layers.map((i) => (
            <div
              key={i}
              className={[
                'perk-theme-overlay__nebula-puff',
                `perk-theme-overlay__nebula-puff--${i % MAX_LAYERS}`,
                `perk-theme-overlay__nebula-puff-tint--${i % COLOR_VARIANTS}`,
              ].join(' ')}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
